var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9521 7.82836C20.8537 7.88996 18.5113 9.18996 18.5113 12.0724C18.6217 15.3596 21.4673 16.5124 21.5161 16.5124C21.4673 16.574 21.0865 18.0828 19.9585 19.6644C19.0633 21.0268 18.0697 22.4004 16.5609 22.4004C15.1257 22.4004 14.6105 21.4924 12.9545 21.4924C11.1761 21.4924 10.6729 22.4004 9.31128 22.4004C7.80248 22.4004 6.73528 20.9532 5.79128 19.6036C4.56488 17.8372 3.52248 15.0652 3.48568 12.4036C3.46088 10.9932 3.73128 9.60676 4.41768 8.42916C5.38648 6.78516 7.11608 5.66916 9.00488 5.63236C10.4521 5.58356 11.7401 6.62596 12.6233 6.62596C13.4697 6.62596 15.0521 5.63236 16.8425 5.63236C17.6153 5.63316 19.6761 5.86596 20.9521 7.82836ZM12.5009 5.35076C12.2433 4.06276 12.9545 2.77476 13.6169 1.95316C14.4633 0.959556 15.8001 0.285156 16.9529 0.285156C17.0265 1.57316 16.5601 2.83636 15.7265 3.75636C14.9785 4.74996 13.6905 5.49796 12.5009 5.35076Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.75ee5a5bffef31b5fd0ee1dfd2c825cb.svg";
export { ForwardRef as ReactComponent };